import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getCurrentNode,
    setNodeInitialView,
} from '../../../GeminiViewerComponent/components/Procedure/features/procedureSlice';

const NodeInitialViewListener = () => {
    const dispatch = useDispatch();
    const currentNode = useSelector(getCurrentNode);

    useEffect(() => {
        const handler = (ev) => {
            const nodeId = ev?.detail?.node_id ?? currentNode?.id ?? null;
            if (nodeId == null) return;

            if (ev?.detail?.clear_initial_view === true) {
                dispatch(
                    setNodeInitialView({
                        node_id: nodeId,
                        initial_view: null,
                    })
                );
                return;
            }

            const view = ev?.detail?.initial_view;
            if (!view) return;

            const parseValue = (value) => {
                if (value === undefined || value === null) return null;

                const number = typeof value === 'number' ? value : Number.parseFloat(value);

                return Number.isNaN(number) ? null : number;
            };

            const isOrbitView = view.init_view_flat_x !== undefined || view.init_view_flat_y !== undefined;
            const parsed = isOrbitView
                ? {
                      init_view_flat_x: parseValue(view.init_view_flat_x),
                      init_view_flat_y: parseValue(view.init_view_flat_y),
                      zoom: parseValue(view.zoom),
                  }
                : {
                      yaw: parseValue(view.yaw),
                      pitch: parseValue(view.pitch),
                      zoom: parseValue(view.zoom ?? view.fov),
                  };

            dispatch(
                setNodeInitialView({
                    node_id: nodeId,
                    initial_view: parsed,
                })
            );
        };

        window.addEventListener('gemini:node-initial-view', handler);

        return () => {
            window.removeEventListener('gemini:node-initial-view', handler);
        };
    }, [dispatch, currentNode?.id]);

    return null;
};

export default NodeInitialViewListener;
